<template>
  <div id="orderlist">
    <!-- <el-row>
      <h2>进销存台账</h2>
    </el-row> -->
    <!-- <el-row>
      <el-form size="small" :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm"
        style="margin: 0">
        <el-col>
          </!-- <el-form-item label="项目点：">
                        <el-select filterable v-model="searchForm.PROJECT" placeholder="请选择" clearable>
                            <el-option v-for="item in projects" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID"></el-option>
                        </el-select>
                    </el-form-item> --/>
          <el-form-item label="选择日期：">
            <el-date-picker v-model="searchForm.START_END" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-button size="small" @click="search()" :loading="loading2">筛选</el-button>
          <el-button size="small" @click="exportTable">导出全版</el-button>
          <el-button size="small" @click="exportSimpleTable">导出简版</el-button>
        </el-col>
      </el-form>
    </el-row> -->
    <el-row>
      <el-col :span="24" v-if="flag == 0">
        <el-table :data="tableData" stripe border style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="大类"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="编码" width="150"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="名称" width="200"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="规格"></el-table-column>
          <el-table-column prop="BEGINING_COUNT" label="期初"></el-table-column>
          <el-table-column prop="BEGINING_WORTH" label="期初金额"></el-table-column>
          <el-table-column prop="INBOUND_COUNT" label="入库合计"></el-table-column>
          <el-table-column prop="INBOUND_WORTH" label="入库金额合计" width="110"></el-table-column>
          <el-table-column prop="OUTBOUND_COUNT" label="出库"></el-table-column>
          <el-table-column prop="OUTBOUND_WORTH" label="出库金额"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="销售退货数量"></el-table-column>
          <el-table-column prop="RETURN_WORTH" label="销售退货金额"></el-table-column>
          <el-table-column prop="TOVRETURN_COUNT" label="采购退货数量"></el-table-column>
          <el-table-column prop="TOVRETURN_WORTH" label="采购退货金额"></el-table-column>
          <el-table-column prop="INNERORDER_COUNT" label="领料出库数量"></el-table-column>
          <el-table-column prop="INNERORDER_WORTH" label="领料出库金额"></el-table-column>
          <el-table-column prop="PDINNERORDER_COUNT" label="生产领料出库数量"></el-table-column>
          <el-table-column prop="PDINNERORDER_WORTH" label="生产领料出库金额"></el-table-column>
          <el-table-column prop="PDOUTERORDER_COUNT" label="生产入库数量"></el-table-column>
          <el-table-column prop="PDOUTERORDER_WORTH" label="生产入库金额"></el-table-column>
          <el-table-column prop="TRANSER_OUT_COUNT" label="调拨出库数量"></el-table-column>
          <el-table-column prop="TRANSER_OUT_WORTH" label="调拨出库金额"></el-table-column>
          <el-table-column prop="TRANSER_IN_COUNT" label="调拨入库数量"></el-table-column>
          <el-table-column prop="TRANSER_IN_WORTH" label="调拨入库金额"></el-table-column>
          <el-table-column prop="TRANSER_BACK_COUNT" label="调拨退回数量"></el-table-column>
          <el-table-column prop="TRANSER_BACK_WORTH" label="调拨退回金额"></el-table-column>
          <el-table-column prop="OVERFLOW_COUNT" label="报溢数量"></el-table-column>
          <el-table-column prop="OVERFLOW_WORTH" label="报溢金额"></el-table-column>
          <el-table-column prop="REPORT_LOSS_COUNT" label="报损数量"></el-table-column>
          <el-table-column prop="REPORT_LOSS_WORTH" label="报损金额"></el-table-column>
          <el-table-column prop="ENDING_COUNT" label="期末"></el-table-column>
          <el-table-column prop="ENDING_WORTH" label="期末金额"></el-table-column>
          <el-table-column prop="PK_WORTH" label="盘盈/亏"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" v-if="flag == 1">
        <el-table :data="tableData" stripe border style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="大类"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="编码" width="150"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="名称" width="200"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="规格"></el-table-column>
          <el-table-column prop="BEGINING_COUNT" label="期初"></el-table-column>
          <el-table-column prop="BEFORE_TAX_BEGINING_WORTH" label="期初金额"></el-table-column>
          <el-table-column prop="INBOUND_COUNT" label="入库合计"></el-table-column>
          <el-table-column prop="BEFORE_TAX_INBOUND_WORTH" label="入库金额合计" width="110"></el-table-column>
          <el-table-column prop="OUTBOUND_COUNT" label="出库"></el-table-column>
          <el-table-column prop="BEFORE_TAX_OUTBOUND_WORTH" label="出库金额"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="销售退货数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_RETURN_WORTH" label="销售退货金额"></el-table-column>
          <el-table-column prop="TOVRETURN_COUNT" label="采购退货数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_TOVRETURN_WORTH" label="采购退货金额"></el-table-column>
          <el-table-column prop="INNERORDER_COUNT" label="领料出库数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_INNERORDER_WORTH" label="领料出库金额"></el-table-column>
          <el-table-column prop="PDINNERORDER_COUNT" label="生产领料出库数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PDINNERORDER_WORTH" label="生产领料出库金额"></el-table-column>
          <el-table-column prop="PDOUTERORDER_COUNT" label="生产入库数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PDOUTERORDER_WORTH" label="生产入库金额"></el-table-column>
          <el-table-column prop="TRANSER_OUT_COUNT" label="调拨出库数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_TRANSER_OUT_WORTH" label="调拨出库金额"></el-table-column>
          <el-table-column prop="TRANSER_IN_COUNT" label="调拨入库数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_TRANSER_IN_WORTH" label="调拨入库金额"></el-table-column>
          <el-table-column prop="TRANSER_BACK_COUNT" label="调拨退回数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_TRANSER_BACK_WORTH" label="调拨退回金额"></el-table-column>
          <el-table-column prop="OVERFLOW_COUNT" label="报溢数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_OVERFLOW_WORTH" label="报溢金额"></el-table-column>
          <el-table-column prop="REPORT_LOSS_COUNT" label="报损数量"></el-table-column>
          <el-table-column prop="BEFORE_TAX_REPORT_LOSS_WORTH" label="报损金额"></el-table-column>
          <el-table-column prop="ENDING_COUNT" label="期末"></el-table-column>
          <el-table-column prop="BEFORE_TAX_ENDING_WORTH" label="期末金额"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PK_WORTH" label="盘盈/亏"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" v-show="total_count">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  props: {
    searchForm1: {
      type: Object,
      default: null,
    },
    currentPage1: {
      type: Number,
      default: 1,
    },
    tableData1: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      // loading1: false,
      // loading: false,
      loading2: false,
      projects: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > (new Date()).getTime() - 3600 * 1000 * 24;
        },
      },
      tableData: this.tableData1,
      searchForm: this.searchForm1,
      total_count: 0,
      pageSize: 15,
      currentPage: this.currentPage1,
      supplierResult: '',
      flag: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    // if (this.SAVE_DSORDER_LIST) {
    //   this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
    //   this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    // } else {
    //   this.currentPage = 1;
    // }
    // if (this.DEPOSIT_DATA_CONDITION) {
    //     this.searchForm = this.DEPOSIT_DATA_CONDITION.CONDITION;
    //     this.currentPage = this.DEPOSIT_DATA_CONDITION.CURRENT_PAGE;
    //     this.tableData = this.DEPOSIT_DATA_CONDITION.DATA;
    // } else {
    //     this.currentPage = 1;
    // }
    // this.queryPro()
    // this.queryData();
  },
  // computed: {
  //   DEPOSIT_DATA_CONDITION() {
  //     return this.$store.state.DEPOSIT_DATA_CONDITION;
  //   },
  // },
  methods: {
    exportTable() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading1 = true
          const params = {
            SERVICE_ID: '10031',
            OTYPE: 34,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            TYPE: 1,
          };
          if (this.searchForm.TAX_SIGN) {
            params.TAX_SIGN = Number(this.searchForm.TAX_SIGN);
          }
          if (this.searchForm.START_END) {
            params.START_DAY = this.searchForm.START_END[0];
            params.END_DAY = this.searchForm.START_END[1];
          }
          if (this.searchForm.SUB_WAREHOUSE) {
            params.SUB_GYS_ID = Number(this.searchForm.SUB_WAREHOUSE);
          }
          if (this.searchForm.TYPE) {
            params.TYPE = Number(this.searchForm.TYPE);
          }
          http.post(params).then((result) => {
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    exportSimpleTable() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10031',
            OTYPE: 35,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            TYPE: 1,
          };
          if (this.searchForm.TAX_SIGN) {
            params.TAX_SIGN = Number(this.searchForm.TAX_SIGN);
          }
          if (this.searchForm.SUB_WAREHOUSE) {
            params.SUB_GYS_ID = Number(this.searchForm.SUB_WAREHOUSE);
          }
          if (this.searchForm.START_END) {
            params.START_DAY = this.searchForm.START_END[0];
            params.END_DAY = this.searchForm.START_END[1];
          }
          if (this.searchForm.TYPE) {
            params.TYPE = Number(this.searchForm.TYPE);
          }
          http.post(params).then((result) => {
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    queryData() {
      this.loading2 = true;
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 32,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        TYPE: 1,
      };
      if (this.searchForm.TAX_SIGN) {
        params.TAX_SIGN = Number(this.searchForm.TAX_SIGN);
        // 0:含税  1：不含税
        if (this.searchForm.TAX_SIGN == 0) {
          this.flag = 0;
        } else if (this.searchForm.TAX_SIGN == 1) {
          this.flag = 1;
        }
      }
      if (this.searchForm.START_END) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.TYPE) {
        params.TYPE = Number(this.searchForm.TYPE);
      }
      if (this.searchForm.SUB_WAREHOUSE) {
        params.SUB_GYS_ID = Number(this.searchForm.SUB_WAREHOUSE);
      }
      http.post(params).then((result) => {
        if (result[0].list) {
          this.tableData = result[0].list;
          this.total_count = result[0].TOTAL_COUNT;
          // this.$store.dispatch("SET_DEPOSIT_DATA_CONDITION", {
          //     // CONDITION: this.searchForm,
          //     DATA: this.tableData,
          //     TOTAL_COUNT: this.total_count,
          //     CURRENT_PAGE: this.currentPage
          // })
          this.loading2 = false;
        } else {
          this.tableData = [];
          this.total_count = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.loading2 = false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading2 = false;
      });
    },
    // queryPro () {
    //     haveDSXMDFun ()
    //     .then(result => {
    //         this.projects = result.length > 0 ? result[0].project : [];
    //     })
    //     .catch(error => {
    //         this.$message.show({ text: error, type: "error" });
    //     });
    // },
    changeProject() {
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // 筛选
    search() {
      this.queryData();
    },
    // 多个供应商
    showSupplier(row) {
      if (row.INBOUND_DETAIL.length === 0) {
        return '';
      } if (row.INBOUND_DETAIL.length === 1) {
        return row.INBOUND_DETAIL[0].SUPPLIER_NAME;
      }
      const supplierArray = [];
      row.INBOUND_DETAIL.forEach((item) => {
        supplierArray.push(item.SUPPLIER_NAME);
      });
      this.supplierResult = supplierArray.join('，');
      return this.supplierResult;
    },
    // 多个入库
    showCount(row) {
      if (row.INBOUND_DETAIL.length === 0) {
        return '';
      } if (row.INBOUND_DETAIL.length === 1) {
        return row.INBOUND_DETAIL[0].TOTAL_COUNT;
      }
      const countArray = [];
      row.INBOUND_DETAIL.forEach((item) => {
        countArray.push(item.TOTAL_COUNT);
      });
      this.countResult = countArray.join('，');
      return this.countResult;
    },
    // 多个入库金额
    showFee(row) {
      if (row.INBOUND_DETAIL.length === 0) {
        return '';
      } if (row.INBOUND_DETAIL.length === 1) {
        return row.INBOUND_DETAIL[0].TOTAL_FEE;
      }
      const feeArray = [];
      row.INBOUND_DETAIL.forEach((item) => {
        feeArray.push(item.TOTAL_FEE);
      });
      this.feeResult = feeArray.join('，');
      return this.feeResult;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.BALANCE_FLAG === 0) {
        return 'fail-row';
      }
      return '';
    },
  },
};
</script>
<style>
.pagination_box {
  float: right;
}

.el-table .fail-row {
  background: oldlace;
}
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/depositPurchase.vue